import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=6028cd6e&scoped=true&"
import script from "./LeftPanel.vue?vue&type=script&lang=js&"
export * from "./LeftPanel.vue?vue&type=script&lang=js&"
import style0 from "./LeftPanel.vue?vue&type=style&index=0&id=6028cd6e&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028cd6e",
  null
  
)

export default component.exports